var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cityId)?_c('SectionEntityGrid',{attrs:{"entity":"events","title":_vm.$t('pages.municipality-view.title-events'),"params":_vm.eventsGridParams}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }